import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'

Vue.use(Router)

export default new Router({
    mode: "hash",
    routes: [
        // 首页
        {
            path: '/',
            name: 'Index',
            meta: {
                title: '首页', // 路由切换时是否需要切换网页title
            },
            component: Index
        },
    ]
})
